import React from "react";

const Languages = () => {
  return (
    <div className="language-container">
      <div className="secondary-text">
        <div className="picture-container">
          Languages & Technologies &nbsp;|&nbsp;&nbsp;
          <ul className="languages">
            <div className="lang-element">
              <img
                src="https://github.com/tandpfun/skill-icons/raw/main/icons/CPP.svg"
                alt=""
                height="40"
                width="40"
              />
              &nbsp;
              <img
                src="https://github.com/tandpfun/skill-icons/raw/main/icons/Python-Dark.svg"
                alt=""
                height="40"
                width="40"
              />
            </div>
            <div className="lang-element">
              <img
                src="https://github.com/tandpfun/skill-icons/raw/main/icons/React-Dark.svg"
                alt=""
                height="40"
                width="40"
              />
              &nbsp;
              <img
                src="https://github.com/tandpfun/skill-icons/raw/main/icons/HTML.svg"
                alt=""
                height="40"
                width="40"
              />
              &nbsp;
              <img
                src="https://github.com/tandpfun/skill-icons/raw/main/icons/CSS.svg"
                alt=""
                height="40"
                width="40"
              />
            </div>
            <div className="lang-element">
              <img
                src="https://github.com/tandpfun/skill-icons/raw/main/icons/Matlab-Dark.svg"
                alt=""
                height="40"
                width="40"
              />
              &nbsp;
              <img
                src="https://github.com/tandpfun/skill-icons/raw/main/icons/R-Dark.svg"
                alt=""
                height="40"
                width="40"
              />
            </div>
            <div className="lang-element">
              <img
                src="https://github.com/tandpfun/skill-icons/raw/main/icons/Linux-Dark.svg"
                alt=""
                height="40"
                width="40"
              />
              &nbsp;
              <img
                src="https://github.com/tandpfun/skill-icons/raw/main/icons/Git.svg"
                alt=""
                height="40"
                width="40"
              />
            </div>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Languages;
